import { Routes, Route, Navigate } from "react-router-dom";
import AboutPage from "./pages/about";
import HomePage from "./pages/home";
import ServicesPage from "./pages/services";
import ExperiencePage from "./pages/experience";
import { FC } from "react";
import { TFunction } from "i18next";
import { currentLanguage } from "./i18n/type";
import { ROUTES } from "./routes";

// import BlogPage from "./pages/blog";
import ContactPage from "./pages/contact";


interface RoutingProps {
  maxWidth: number;
  screenWidth: number;
  screenHeight: number;
  t: TFunction<"translation", undefined>;
}

const Routing: FC<RoutingProps> = (props: RoutingProps) => {
  const { t, maxWidth, screenWidth, screenHeight } = props;
  return (
    <Routes>
      <Route
        path="/"
        element={<Navigate to={`/${currentLanguage}`} replace />}
      />
      <Route path={currentLanguage}>
        <Route
          path={ROUTES.home[currentLanguage]}
          element={
            <HomePage
              maxWidth={maxWidth}
              screenWidth={screenWidth}
              screenHeight={screenHeight}
              t={t}
            />
          }
        />
        <Route
          path={ROUTES.about[currentLanguage]}
          element={
            <AboutPage
              maxWidth={maxWidth}
              screenWidth={screenWidth}
              screenHeight={screenHeight}
              t={t}
            />
          }
        >

          <Route
            path="*"
            element={<Navigate to={`/${currentLanguage}`} replace />}
          />
        </Route>
        
        <Route
          path={ROUTES.services[currentLanguage]}
          element={
            <ServicesPage
              maxWidth={maxWidth}
              screenWidth={screenWidth}
              screenHeight={screenHeight}
              t={t}
            />
          }
        />
        
        <Route
          path={ROUTES.experience[currentLanguage]}
          element={
            <ExperiencePage
              maxWidth={maxWidth}
              screenWidth={screenWidth}
              screenHeight={screenHeight}
              t={t}
            />
          }
        />
   
        <Route
          path={ROUTES.contact[currentLanguage]}
          element={
            <ContactPage
              maxWidth={maxWidth}
              screenWidth={screenWidth}
              screenHeight={screenHeight}
              t={t}
            />
          }
        />
        <Route
          path="*"
          element={<Navigate to={`/${currentLanguage}`} replace />}
        />
      </Route>
      <Route
        path="*"
        element={<Navigate to={`/${currentLanguage}`} replace />}
      />
    </Routes>
  );
};

export default Routing;
